module.exports = __webpack_public_path__ + "img/20190611_153430_039.7d08e5dd.jpg";